import { SubmittableFilter } from 'Components/Filters/SubmittableFilter';
import * as $ from 'jquery';
import { Filters } from './Filters';

export class SelectTypeFilters extends SubmittableFilter {
  protected static readonly Selector = {
    SELECT: '.js_filter_select',
  }

  public static init() {
	this.initSelectricMinWidth();
    $(this.Selector.SELECT).selectric({
      arrowButtonMarkup: /* html */`<i class="fa fa-chevron-down"></i>`,
      nativeOnMobile: false,
      onChange: (element) => {
        this.applyReadyToBeSubmittedClass($(element));
        let changeHappenedWithinSidePanel = $(element).parents(Filters.Selector.MORE_FILTERS_SIDE_SECTION).length > 0;

        this.syncSelectTypeFilterWithItsEquivalent(element, {
          targetSelector: changeHappenedWithinSidePanel ? Filters.Selector.NORMAL_FILTERS_SECTION : Filters.Selector.MORE_FILTERS_SIDE_SECTION
        });
      },
    });
  }
}
import { SubmittableFilter } from 'Components/Filters/SubmittableFilter';
import * as $ from 'jquery';
import { Filters } from './Filters';

export class SelectTypeFilters extends SubmittableFilter {
  protected static readonly Selector = {
    SELECT: '.js_filter_select',
  }

  public static init() {
	this.initSelectricMinWidth();
    $(this.Selector.SELECT).selectric({
      arrowButtonMarkup: /* html */`<i class="fa fa-chevron-down"></i>`,
      nativeOnMobile: false,
      onChange: (element) => {
        this.applyReadyToBeSubmittedClass($(element));
        let changeHappenedWithinSidePanel = $(element).parents(Filters.Selector.MORE_FILTERS_SIDE_SECTION).length > 0;

        this.syncSelectTypeFilterWithItsEquivalent(element, {
          targetSelector: changeHappenedWithinSidePanel ? Filters.Selector.NORMAL_FILTERS_SECTION : Filters.Selector.MORE_FILTERS_SIDE_SECTION
        });
      },
    });
  }
}
